import { ReactNode } from 'react';
import { cn } from './cn';

/** Shared input styling for text inputs, selects and textareas. */
export const inputCls =
  'w-full rounded-lg border border-line bg-surface-inset px-3 py-2 text-[13px] text-fg placeholder:text-fg-ghost focus:border-accent/50 focus:outline-none';

export const Label = ({ children, htmlFor }: { children: ReactNode; htmlFor?: string }) => (
  <label htmlFor={htmlFor} className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-fg-faint">
    {children}
  </label>
);

export const Field = ({ label, children, className }: { label?: ReactNode; children: ReactNode; className?: string }) => (
  <div className={cn('mb-3', className)}>
    {label ? <Label>{label}</Label> : null}
    {children}
  </div>
);
